import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer, Toast } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaCubes,
  FaBorderAll,
  FaRulerCombined,
  FaExpand,
  FaMapMarkerAlt,
  FaSave,
  FaTimes,
} from "react-icons/fa";
import API from "../hooks/Fetchs";
import "./estylos.css"
import { Navigate } from "react-router-dom";
import HeaderRoot from "../hooks/HeaderRoot";
const convertirImagenAWebP = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onloadend = () => {
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(
        (blob) => {
          resolve(
            new File([blob], file.name.split(".")[0] + ".webp", {
              type: "image/webp",
            })
          );
        },
        "image/webp"
      );
    };
  });
};

const Crear = ({ isModal = false, onSuccess }) => {
  const [formData, setFormData] = useState({
    direccion: "",
    lugar: "",
    cantidad_hectareas: "",
    superficie_terreno: "",
    medida_frente: "",
    medida_fondo: "",
    superficie_cubierta: "",
    superficie_semicubierta: "",
    descripcion: "",
    tipo_inmueble: "",
    ubicacion: "",
    img_portada: [],
    img: [],
  });
  const [mensaje, setMensaje] = useState("");
  const toastRef = useRef(null);

  useEffect(() => {
    if (mensaje && toastRef.current) {
      toastRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [mensaje]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (e, type) => {
    const files = Array.from(e.target.files);
    if (type === "img_portada" && files.length > 3) {
      alert("Solo puedes seleccionar hasta 3 imágenes de portada.");
      return;
    }
    if (type === "img" && files.length > 7) {
      alert("Solo puedes seleccionar hasta 7 imágenes adicionales.");
      return;
    }

    const webpFiles = await Promise.all(files.map((file) => convertirImagenAWebP(file)));

    setFormData(prev => ({
      ...prev,
      [type]: [...prev[type], ...webpFiles]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.tipo_inmueble) {
      alert("Debes seleccionar un tipo de inmueble.");
      return;
    }
    if (formData.img_portada.length === 0) {
      alert("Debes seleccionar al menos una imagen de portada.");
      return;
    }

    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "img_portada" && key !== "img") {
        formDataToSend.append(key, value);
      }
    });

    formData.img_portada.forEach((file, index) => {
      formDataToSend.append(`img_portada_${index + 1}`, file);
    });

    formData.img.forEach((file, index) => {
      formDataToSend.append(`img_${index + 1}`, file);
    });

    try {
      const response = await axios.post(
        API.create,
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data?.message) {
        setMensaje("✅ Carga exitosa. Puedes agregar otra propiedad.");
        setFormData({
          direccion: "",
          lugar: "",
          cantidad_hectareas: "",
          superficie_terreno: "",
          medida_frente: "",
          medida_fondo: "",
          superficie_cubierta: "",
          superficie_semicubierta: "",
          descripcion: "",
          tipo_inmueble: "",
          ubicacion: "",
          img_portada: [],
          img: [],
        });

        document.querySelectorAll('input[type="file"]').forEach((input) => {
          input.value = "";
        });

        if (onSuccess) onSuccess();
        window.location.reload();
      }
    } catch (error) {
      setMensaje("❌ Error al cargar la propiedad");
      console.error("Error:", error);
    }
  };

  const onDragStart = (e, index, tipo) => {
    e.dataTransfer.setData("index", index);
    e.dataTransfer.setData("tipo", tipo);
  };

  const onDrop = (e, dropIndex, tipo) => {
    const dragIndex = parseInt(e.dataTransfer.getData("index"));
    const dragTipo = e.dataTransfer.getData("tipo");

    if (tipo !== dragTipo) return;

    const items = [...formData[tipo]];
    const [draggedItem] = items.splice(dragIndex, 1);
    items.splice(dropIndex, 0, draggedItem);

    setFormData(prev => ({
      ...prev,
      [tipo]: items
    }));
  };

  const removeImage = (index, type) => {
    setFormData(prev => ({
      ...prev,
      [type]: prev[type].filter((_, i) => i !== index)
    }));
  };

  return (
    <>
      <HeaderRoot />
      <div className="p-2 container crear-form">
        {/* Encabezado */}
        <h2
          className="text-center mb-4 text-success fw-bold"
          style={{
            fontSize: "2rem", // Tamaño de fuente más grande
            fontWeight: "900", // Peso de la fuente más grueso
            textTransform: "uppercase", // Texto en mayúsculas
            letterSpacing: "1px", // Espaciado entre letras
          }}
        >
          Agregar Nueva Propiedad
        </h2>


        {/* Notificaciones */}
        <div ref={toastRef}>
          <ToastContainer position="top-center" className="mt-3">
            <Toast
              show={!!mensaje}
              onClose={() => setMensaje("")}
              delay={500}
              autohide
              bg={mensaje.includes("✅") ? "success" : "danger"}
            >
              <Toast.Header>
                <strong className="me-auto">Notificación</strong>
              </Toast.Header>
              <Toast.Body className="text-white d-flex align-items-center">
                <span className="me-2">{mensaje.charAt(0)}</span>
                <span>{mensaje.slice(2)}</span>
              </Toast.Body>
            </Toast>
          </ToastContainer>
        </div>

        {/* Formulario */}
        <form onSubmit={handleSubmit} className="w-100">
          <div className="row g-3">
            {/* Dirección y Lugar */}
            <div className="col-md-6">
              <label className="form-label d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                Dirección <span className="text-danger ms-1">*</span>
              </label>
              <input
                type="text"
                name="direccion"
                className="form-control"
                value={formData.direccion}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                Lugar
              </label>
              <input
                type="text"
                name="lugar"
                className="form-control"
                value={formData.lugar}
                onChange={handleChange}
              />
            </div>

            {/* Tipo de Inmueble */}
            <div className="col-md-6">
              <label className="form-label d-flex align-items-center">
                <FaCubes className="me-2" />
                Tipo de Inmueble <span className="text-danger ms-1">*</span>
              </label>
              <select
                name="tipo_inmueble"
                className="form-select"
                value={formData.tipo_inmueble}
                onChange={handleChange}
                required
              >
                <option value="">Seleccionar tipo</option>
                <option value="campos">Campo</option>
                <option value="casa">Casa</option>
                <option value="departamentos">Departamento</option>
                <option value="forestaciones">Forestaciones</option>
                <option value="galpones">Galpón</option>
                <option value="oficinas">Locales y Oficinas</option>
                <option value="quintas">Quinta</option>
                <option value="terreno">Terreno</option>
                <option value="otros">Otras Propiedades</option>
              </select>
            </div>

            {/* Medidas */}
            <div className="col-md-12">
              <div className="card p-4 shadow-sm">
                <h5 className="mb-3">Medidas</h5>
                <div className="row g-3">


                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center">
                      <FaRulerCombined className="me-2" />
                      Cantidad de Hectáreas
                    </label>
                    <input
                      type="number"
                      name="cantidad_hectareas"
                      className="form-control"
                      value={formData.cantidad_hectareas}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center">
                      <FaExpand className="me-2" />
                      Superficie del Terreno (m²)
                    </label>
                    <input
                      type="number"
                      name="superficie_terreno"
                      className="form-control"
                      value={formData.superficie_terreno}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center">
                      <FaBorderAll className="me-2" />
                      Medida del Frente
                    </label>
                    <input
                      type="number"
                      name="medida_frente"
                      className="form-control"
                      value={formData.medida_frente}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center">
                      <FaBorderAll className="me-2" />
                      Medida de Fondo
                    </label>
                    <input
                      type="number"
                      name="medida_fondo"
                      className="form-control"
                      value={formData.medida_fondo}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center">
                      <FaCubes className="me-2" />
                      Superficie Cubierta (m²)
                    </label>
                    <input
                      type="number"
                      name="superficie_cubierta"
                      className="form-control"
                      value={formData.superficie_cubierta}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center">
                      <FaCubes className="me-2" />
                      Superficie Semicubierta (m²)
                    </label>
                    <input
                      type="number"
                      name="superficie_semicubierta"
                      className="form-control"
                      value={formData.superficie_semicubierta}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Descripción */}
            <div className="col-md-12">
              <label className="form-label">Descripción</label>
              <textarea
                className="form-control"
                name="descripcion"
                value={formData.descripcion}
                onChange={handleChange}
                rows="4"
              />
            </div>

            {/* Ubicación */}
            <div className="col-md-12">
              <label className="form-label d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                Ubicación en Google Maps
              </label>
              <input
                type="text"
                name="ubicacion"
                className="form-control"
                value={formData.ubicacion}
                onChange={handleChange}
              />
            </div>

            {/* Imágenes */}

            {/* Imágenes de Portada */}
            <div className="col-md-6">
              <label className="form-label">Imágenes de Portada (hasta 3)</label>
              <input
                type="file"
                accept="image/*"
                name="img_portada"
                className="form-control"
                multiple
                onChange={(e) => handleFileChange(e, "img_portada")}
              />
              <div className="d-flex mt-2 flex-wrap gap-2">
                {formData.img_portada.map((file, index) => (
                  <div
                    key={index}
                    className="thumbnail-container"
                    draggable
                    onDragStart={(e) => onDragStart(e, index, "img_portada")}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => onDrop(e, index, "img_portada")}
                  >
                    <img
                      src={URL.createObjectURL(file)}
                      alt={`preview ${index}`}
                      className="thumbnail"
                    />
                    <button
                      type="button"
                      className="btn-close thumbnail-close"
                      onClick={() => removeImage(index, "img_portada")}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Imágenes Adicionales */}
            <div className="col-md-6">
              <label className="form-label">Imágenes Adicionales (hasta 7)</label>
              <input
                type="file"
                accept="image/*"
                name="img"
                className="form-control"
                multiple
                onChange={(e) => handleFileChange(e, "img")}
              />
              <div className="d-flex mt-2 flex-wrap gap-2">
                {formData.img.map((file, index) => (
                  <div
                    key={index}
                    className="thumbnail-container"
                    draggable
                    onDragStart={(e) => onDragStart(e, index, "img")}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => onDrop(e, index, "img")}
                  >
                    <img
                      src={URL.createObjectURL(file)}
                      alt={`preview ${index}`}
                      className="thumbnail"
                    />
                    <button
                      type="button"
                      className="btn-close thumbnail-close"
                      onClick={() => removeImage(index, "img")}
                    />
                  </div>
                ))}
              </div>
            </div>


            {/* Botones */}
            <div className="d-grid gap-2 mt-4 mt-5 mb-4 ">
              <button
                type="submit"
                className="btn btn-success btn-lg rounded-pill col-12 col-sm-10 col-lg-5 mx-auto d-block"
              >
                <FaSave className="me-2  " /> Guardar Propiedad
              </button>

            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Crear;